import styled from "styled-components";
import {
    TextField,
} from "@material-ui/core";
import { useState } from "react";


const TextFieldLabel = styled.div`
font-family: Roboto;
font-size: 15px;
font-weight: 500;
`

const TextFieldContainer = styled.div`
  width: 100%;
`;

const ModifiedProcedureSdnTitle = styled.div`
display:grid;
grid-template-columns:1fr 20px 1.5fr
width:100%;

`;

const ModifiedProcedureContainer = styled.div`
padding-top:20px;
width:100%
`;

const MetadataContainerStyled = styled.div`
    position: absolute;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 grey;
    background-color: #fff;
    // margin-top: 10px;
    cursor: pointer;
    min-width: 110px;
    z-index:2;
    padding: 10px;
    width:700px;
    max-height: 500px;
    overflow-y: scroll;
`
const MetadataMenuHeadingStyled = styled.div`
  display: flex;
  font-weight: 600;
`
const MetadataMenuItemProjStyled = styled.div`
  width: 15%;
`

const MetadataMenuItemSDNStyled = styled.div`
  width: 30%;
  margin: 0 0 20px 0;
`

const MetadataMenuItemRevStyled = styled.div`
  width: 12%;
`
const MetadataMenuItemTitleStyled = styled.div`
  width: 43%;
`
const MetadataItemListStyled = styled.div`
  display: flex;
`
const SdnStyled = styled.div`
  position: relative;
`

const DeviationNewProjectProcedureForm = (props) => {
    const { modifiedProcedureSdn,
        onChangeSdn,
        modifiedProcedureTitle,
        onChangeModifiedProcedureTitle,
        modifiedProcedureUrl,
        onChangeModifiedProcedureUrl,
        modifiedRevision,
        onChangeModifiedProcedureRevision,
        modifiedEffectiveDate,
        onChangeModifiedProcedureEffectiveDate,
        onUrlBlur,
        helperText,
        myRRDocs,
        error,
    } = props

    const sdnMetadata = myRRDocs
    const [newEntry, setNewEntry] = useState({
        sdn: modifiedProcedureSdn || '',
        name: modifiedProcedureTitle || '',
        effectiveDate: modifiedEffectiveDate,
        url: modifiedProcedureUrl || '',
        rev: modifiedRevision || '',
        categoryId: ''
    })

    const [metaData, setMetadata] = useState([]);
    const [isMetadataVisible, setIsMetadataVisible] = useState(false);

    const handleNewEntryChange = (e) => {
        // filter the result for metadata on sdn changed
        let temp = [];
        let isMetadataVisible = false;
        if (e.target.value.length >= 3 && sdnMetadata) {
            isMetadataVisible = true;
            temp = sdnMetadata.filter((sdnMetadataRow) => {
                // return sdnMetadataRow.sdn.includes(e.target.value) // taking too much of time
                return sdnMetadataRow.sdn.startsWith(e.target.value); // fast execution
                // return sdnMetadataRow.sdn.indexOf(e.target.value) // taking too much of time
            })
        }

        setNewEntry({
            ...newEntry, sdn: e.target.value ? e.target.value : '',
        })
        setMetadata(temp)
        setIsMetadataVisible(isMetadataVisible)

        onChangeSdn({
            ...newEntry,
            sdn: e.target.value ? e.target.value : '',
        })
    }

    const handleMetadataSelect = (id) => {
        const temp = sdnMetadata.filter((sdnMetadataRow) => {
            return sdnMetadataRow.id == id
        })

        setNewEntry({
            ...newEntry,
            sdn: temp[0].sdn,
            name: temp[0].documentTitle,
            effectiveDate: temp[0].effectiveDate,
            url: temp[0].documentLink,
            rev: temp[0].documentRevision
        })
        setIsMetadataVisible(false)
        onChangeSdn({
            ...newEntry,
            sdn: temp[0].sdn,
            name: temp[0].documentTitle,
            effectiveDate: temp[0].effectiveDate,
            url: temp[0].documentLink,
            rev: temp[0].documentRevision
        })
    }

    return (
        <ModifiedProcedureContainer>
            <ModifiedProcedureSdnTitle>
                <SdnStyled>
                    <TextField label="SDN" value={modifiedProcedureSdn} onChange={handleNewEntryChange} fullWidth margin="normal" variant="outlined" />
                    {!!isMetadataVisible && !!metaData.length && <MetadataContainerStyled>
                        <MetadataMenuHeadingStyled>
                            <MetadataMenuItemProjStyled>Project No.</MetadataMenuItemProjStyled>
                            <MetadataMenuItemSDNStyled>SDN</MetadataMenuItemSDNStyled>
                            <MetadataMenuItemRevStyled>Rev</MetadataMenuItemRevStyled>
                            <MetadataMenuItemTitleStyled>Title</MetadataMenuItemTitleStyled>
                            {/* <MetadataMenuItemRevStyled>Rev No</MetadataMenuItemRevStyled>
                        <MetadataMenuItemProjStyled>Effective</MetadataMenuItemProjStyled>
                        <MetadataMenuItemProjStyled>Link</MetadataMenuItemProjStyled> */}

                        </MetadataMenuHeadingStyled>
                        {metaData.map((item) => {
                            return <MetadataItemListStyled key={item.id} onClick={() => handleMetadataSelect(item.id)}>
                                <MetadataMenuItemProjStyled> {item.projectNumber}</MetadataMenuItemProjStyled>
                                <MetadataMenuItemSDNStyled> {item.sdn}</MetadataMenuItemSDNStyled>
                                <MetadataMenuItemRevStyled> {item.documentRevision}</MetadataMenuItemRevStyled>
                                <MetadataMenuItemTitleStyled> {item.documentTitle}</MetadataMenuItemTitleStyled>
                                {/* <MetadataMenuItemTitleStyled> {item.documentVersionNumber}</MetadataMenuItemTitleStyled>
                      <MetadataMenuItemTitleStyled> {item.effectiveDate}</MetadataMenuItemTitleStyled>
                      <MetadataMenuItemTitleStyled> {item.documentLink}</MetadataMenuItemTitleStyled> */}
                            </MetadataItemListStyled>
                        })}
                    </MetadataContainerStyled>}
                </SdnStyled>
                <div />
                <TextField label="Title" value={modifiedProcedureTitle} onChange={onChangeModifiedProcedureTitle} fullWidth margin="normal" variant="outlined" />
                <TextField label="Rev" value={modifiedRevision} onChange={onChangeModifiedProcedureRevision} fullWidth margin="normal" variant="outlined" />
                <div />
                <TextField
                    name="effectiveDate"
                    label="Effective Date"
                    InputLabelProps={{ shrink: true, required: false }}
                    type="date"
                    value={modifiedEffectiveDate}
                    onChange={onChangeModifiedProcedureEffectiveDate}
                    fullWidth margin="normal" variant="outlined"
                />
            </ModifiedProcedureSdnTitle>
            {/* <TextField label="Url" value={this.state.modifiedProcedureUrl} onChange={event => this.setState({modifiedProcedureUrl:event.target.value})} fullWidth margin="normal" variant="outlined" /> */}
            <TextField label="Url"
                value={modifiedProcedureUrl}
                onChange={onChangeModifiedProcedureUrl}
                onBlur={onUrlBlur}
                fullWidth
                margin="normal"
                variant="outlined"
                helperText={helperText}
                error={error}
            />
        </ModifiedProcedureContainer>
    );
}

export const DeviationForNewProjectProcedure = (props) => {
    const { deviationReasoning,
        onDeviationReasoningChange,
    } = props
    return (
        <>
            <DeviationNewProjectProcedureForm {...props} />
            <TextFieldLabel>
                Reason for deviation*
            </TextFieldLabel>
            <TextFieldContainer>
                <TextField placeholder="Start typing..." value={deviationReasoning} onChange={onDeviationReasoningChange} multiline fullWidth margin="normal" variant="outlined" />
            </TextFieldContainer>
        </>);
}